export default {
    "login": {
        "userLogin": "Käyttäjän kirjautuminen",
        "title": "Mobiili- ja sähköpostitilit ovat erillisiä. Huomioi tilityyppisi.",
        "mobileLogin": "Puhelin",
        "emailLogin": "Sähköposti",
        "email": "Sähköposti",
        "loginBtn": "Kirjaudu sisään",
        "autoLogin": "Muista minut",
        "retransmission": "Lähetä uudelleen {item}s",
        "formList": {
            "0": {
                "label": "Syötä puhelinnumerosi",
                "placeholder": "Lähetä koodi"
            },
            "1": {
                "label": "Vahvistuskoodi",
                "placeholder": "Syötä"
            },
            "2": {
                "label": "Syötä sähköpostiosoitteesi"
            }
        },
        "btn": {
            "submit": "Luo uusi tili",
            "title": "Oikeat tiedot ovat erittäin tärkeitä. Täytä ne huolellisesti."
        },
        "rule": {
            "phone": {
                "requiredMsg": "Puhelinnumeron muoto on virheellinen",
                "patternMsg": "Puhelinnumeroa ei ole rekisteröity. Luo uusi tili."
            },
            "authCode": {
                "requiredMsg": "Virheellinen vahvistuskoodi. Yritä uudelleen."
            },
            "email": {
                "requiredMsg": "Sähköpostiosoitteen muoto on virheellinen",
                "patternMsg": "Sähköpostia ei ole rekisteröity. Luo uusi tili."
            }
        },
        "success": "Lähetys onnistui",
        "error": "Lähetys epäonnistui",
        "loginSuccess": "Kirjautuminen onnistui",
        "account": {
            "accountTitle": 'Kirjaudu sisään',
            "registerTitle": 'Rekisteröidy',
            "resetTitle": 'Aseta salasana',
            "password": 'Salasana',
            "placeholder": 'Syötä salasana',
            "codeLogin": 'Kirjaudu vahvistuskoodilla',
            "accountLogin": 'Kirjaudu salasanalla',
            "forgotPassword": 'Unohditko salasanan?',
            "registerTips":[
                'Eikö sinulla ole vielä tiliä?', 
                'Rekisteröidy', 
                'Tili on jo olemassa',
                'Rekisteröidy nyt',
            ],
            "checkRule": [
                '8–20 merkkiä',
                'Vähintään yksi iso kirjain',
                'Vähintään yksi pieni kirjain',
                'Vähintään yksi numero', 
                'Salasanat eivät täsmää'
            ],
            "errorTips": [
                'Virheellinen salasana', 
                'Kirjautuminen epäonnistui', 
                'Tiliä ei ole olemassa'
            ],
            "reset":[
                'Nollaa salasana', 
                "Seuraava",
                'Uusi salasana ei voi olla sama kuin edellinen', 
                'Ohita',
                'Salasanan asettaminen onnistui'
            ],
            "setPasswordTips":'Salasanan on oltava 8–20 merkkiä pitkä ja sisällettävä isoja kirjaimia, pieniä kirjaimia ja numeroita.',
            "confirmPassword": "Vahvista salasana",
        },
        "loginAndRegister": "Rekisteröidy / Kirjaudu sisään",
        "codeSuccess": "Vahvistuskoodi on lähetetty, tarkista viestisi",
        "switchButton": "Kirjaudu salasanalla",
        "switchButton1": "Kirjaudu vahvistuskoodilla",
        "loginTips": "Rekisteröimätön tili rekisteröidään automaattisesti onnistuneen kirjautumisen yhteydessä.",
        "otherLogin": "Muut kirjautumistavat",
        "newEmailLogin": "Kirjaudu sähköpostilla",
        "newPhoneLogin": "Kirjaudu puhelinnumerolla",
        "bindLineTips": "Tai",
        "bindEmail": "Kirjaudu yhdistetyllä sähköpostilla",
        "bindPhone": "Kirjaudu yhdistetyllä puhelinnumerolla",
        bindAndContinue: "Yhdistä ja jatka",
        bind: "Yhdistä",
        bindEmailTitle: 'Yhdistä sähköposti',
        bindEmailTips1: "{item}-sähköpostia ei löytynyt",
        bindEmailTips2: "Yhdistä sähköposti jatkaaksesi",
        bindEmailTips3: "Sähköpostia ei ole yhdistetty. Yhdistä kirjautuaksesi ja palauttaaksesi salasanan.",
        boundTitle: 'Oletko rekisteröitynyt aiemmin?',
        boundCenterTitle1:'Jos olet uusi käyttäjä',
        boundCenterTips1:'Luo tili ja aloita',
        boundCenterTitle2:'Jos sinulla on jo tili',
        boundCenterTips2:'Yhdistä synkronoidaksesi tiedot',
        boundCenterTips3:'Yhdistä rekisteröity tili',
        boundCenterTips4:'Suositus',
        boundCenterTips5:'Yhdistä {item}-tili olemassa olevaan tiliin',
        boundCenterTips6:'Tiedot ja raportit synkronoidaan',
        boundButton1: 'Luo tili palvelulla {item}',
        boundButton2: 'Yhdistä olemassa oleva tili',
        phoneCode:"Kirjaudu SMS-koodilla",
        phonePassword:"Puhelin ja salasana",
        emailCode:"Kirjaudu sähköpostikoodilla",
        emailPassword:"Sähköposti ja salasana",
        accountDoesNotExist:"Tätä tiliä ei ole vielä rekisteröity. Viimeistele rekisteröinti sähköpostivahvistuskoodilla tai {item} in kautta.",
        toRegister:"Rekisteröidy",
        bindNow: "Linkitä nyt",
        "bindError":[
            'Yhdistäminen epäonnistui',
            'Yhdistämisen poisto onnistui',
            'Yhdistämisen poisto epäonnistui',
            'Valtuutus epäonnistui',
            'Valtuutus epäonnistui, tilitietoja ei saatu haettua',
            'Yhdistäminen onnistui',
            'Tiliä ei ole olemassa. Yhdistä rekisteröity tili.',
            'Yhdistäminen epäonnistui. Tämä tili on jo yhdistetty {item}-tiliin. [{nickname}]',
            'Tämä tili on valtuutettu ja rekisteröity. Yhdistämisen poistoa ei tueta.',
            'Tiliä ei ole olemassa. Käytä vahvistuskoodia kirjautumiseen ja rekisteröitymiseen.',
        ],
        "accountSecurity": {
            "faceBook": "Facebook-tili",
            "google": "Google-tili",
            "isBind": "Ei yhdistetty",
            "dialogTitle": "Vahvista yhdistämisen poisto?",
            "dialogCenter": "Kun {item} yhdistäminen on poistettu, et voi enää käyttää sitä tälle tilille kirjautumiseen.",
            "bindFailure": "Yhdistäminen epäonnistui",
            "bindFailureTips": "Sinun {item}-tilisi on jo yhdistetty alla olevaan tiliin. Jos haluat vaihtaa sen nykyiseen tiliin, kirjaudu ensin alla olevaan tiliin ja poista yhdistäminen.",
            "returnButton": "Vahvista ja palaa"
        },
        bindEmailError: [
            "Sähköposti on jo käytössä."
        ],
    },
    "register": {
        "mobileRegister": "Rekisteröidy puhelinnumerolla",
        "emailRegister": "Rekisteröidy sähköpostilla",
        "enroll": "Puhelinnumero on jo rekisteröity",
        "search": "Hae",
        "title": "Mobiili- ja sähköpostitilit ovat erillisiä. Huomioi tilityyppisi.",
        "needRead": {
            "agree": "Olen lukenut ja hyväksynyt",
            "privacy": "Käyttäjän tietosuojakäytäntö"
        },
        "register": "Rekisteröidy",
        "check": "Valitse \"Käyttäjän tietosuojakäytäntö\"",
        "newUser": "Uuden käyttäjän rekisteröinti",
        "form": {
            "labelList": {
                "0": "Nimi",
                "1": "* Sukupuoli",
                "2": "* Pituus",
                "3": "* Ikä"
            }
        },
        "placeholder": {
            "0": "Syötä nimesi",
            "1": "Syötä pituutesi",
            "2": "Syötä ikäsi"
        },
        "unit": {
            "0": "Metrinen",
            "1": "Imperiaalinen",
            "2": "vuotta"
        },
        "sexOptions": {
            "male": "Mies",
            "female": "Nainen"
        },
        "btn": "Lähetä",
        "rules": {
            "metricheight": {
                "0": "Sallittu pituusalue on 2 jalkaa 3 tuumaa – 6 jalkaa 7 tuumaa. Syötä uudelleen."
            },
            "heightMsg": {
                "0": "Sallittu pituusalue on 70–200 cm. Syötä uudelleen."
            },
            "ageMsg": {
                "0": "Sallittu ikähaarukka on 10–99 vuotta. Syötä uudelleen."
            },
            "agePointMsg": {
                "0": "Syötit muun kuin kokonaisluvun: iän on oltava kokonaisluku. Syötä oikea ikä."
            }
        },
        "success": "Rekisteröinti onnistui",
        "userMessage": "Syötä käyttäjänimesi",
        "verify": "Syötä 4-numeroinen vahvistuskoodi",
        "errorMsg": "Pituuden muoto ei tue desimaaleja. Syötä uudelleen.",
        "enrollEmail": "Sähköpostiosoite on jo rekisteröity.",
        "abnormalMsg": "Rekisteröintivirhe"
    },
    "model": {
        "loading": "Mallia luodaan, odota hetki.",
        "modelLoading": "Ladataan mallia...",
        "tabPane": {
            "0": {
                "title": "Syvyyshavainnointiteknologia",
                "msg": "Tarkka 3D-skannaus tallentaa kehon yksityiskohdat millimetrin tarkkuudella ja tekee harjoittelun jälkeiset kehon muutokset selkeästi näkyviksi."
            },
            "1": {
                "title": "BDA-kehonkoostumusalgoritmi",
                "msg": "Visbody käyttää huippuluokan BDA-järjestelmää kehonkoostumuksen määrittämiseen. Tämä kehon tilavuuteen perustuva menetelmä arvioi tarkemmin lihavuuteen liittyviä terveysriskejä."
            },
            "2": {
                "title": "Mahdolliset virhetekijät",
                "msg": "Löysä vaatetus, vieraat esineet kehossa jne. aiheuttavat eriasteisia virheitä. Jos haluat tarkimmat tiedot, käytä ihonmyötäisiä vaatteita tai vähennä vaatetusta."
            },
            "3": {
                "title": "Raportin avaaminen",
                "msg": "Suosittelemme lisäämään sivun kirjanmerkkeihin raportin myöhempää tarkastelua varten. Voit myös lähettää tämän raportin sähköpostiisi tallennettavaksi."
            }
        },
        "collect": {
            "0": "Lisää tämä sivu kirjanmerkkeihin,",
            "1": "jotta voit tarkastella raporttia myöhemmin."
        },
        "know": "Normaali",
        "reminder": {
            "0": "Muistutus",
            "1": "3D-mallisi on luotu. Voit kiertää mallia pyyhkäisemällä sivusuunnassa.",
            "2": "Raporttisi on valmis. Voit tarkastella sitä napsauttamalla \"Näytä raportti\".",
            "3": "Asennon arviointi epäonnistui. Tarkastele kehonkoostumusraporttia.",
            "4": "Kehonkoostumuksen mittaus epäonnistui. Tarkastele asentoanalyysiraporttia.",
            "5": "Mittaus epäonnistui. Yritä uudelleen laitteella.",
            "6": "Kehonkoostumuksen mittaus epäonnistui. Yritä uudelleen laitteella.",
            "7": "Asennon arviointi epäonnistui. Yritä uudelleen laitteella."
        },
        "btn": {
            "viewReport": "Näytä raportti",
            "bodyReport": "Näytä kehonkoostumusraportti",
            "postureReport": "Näytä asentoanalyysiraportti",
            "lastReport": "Näytä edellinen raportti",
            "loading": "Ladataan..."
        }
    },
    "report": {
        "btn": {
            "download": "Lataa raportti",
            "send": "Lähetä raportti",
            "report": "Raportti"
        },
        "reportSuccess": "Raportin luominen onnistui",
        "tabPane": {
            "labelList": {
                "0": "Mittausaika",
                "1": "Mittauskohde",
                "2": "Kehonkoostumus",
                "3": "Asennon arviointi",
                "4": "Olkapään toiminta"
            }
        },
        "sendEmail": "Lähetä sähköpostiin:",
        "requiredMsg": "Syötä sähköpostiosoitteesi",
        "patternMsg": "Syötä oikea sähköpostiosoite",
        "send": "Lähetä",
        "download": "Lataa raportti",
        "sendReport": "Lähetä raportti"
    },
    "sidebar": {
        "successMsg": {
            "sex": "Sukupuoli päivitetty onnistuneesti",
            "height": "Pituus päivitetty onnistuneesti",
            "age": "Ikä päivitetty onnistuneesti"
        },
        "logOut": "Kirjaudu ulos",
        "personal": "Profiili",
        "cut": "Vaihda yksiköt / kieli",
        "unit": {
            "0": "Metrinen (kg, cm)",
            "1": "Imperiaalinen (ft, in, lb)"
        },
        "read": {
            "reading": "Lue",
            "privacy": "Käyttäjän tietosuojakäytäntö"
        },
        "setting": "Asetukset",
        "form": {
            "labelList": {
                "0": "Puhelinnumero",
                "1": "Yksiköt",
                "2": "Kieli",
                "3": "Lempinimi",
                "4": "Sukupuoli",
                "5": "Pituus",
                "6": "Ikä"
            }
        },
        "placeholder": {
            "0": "Muokkaa lempinimeä",
            "1": "Muokkaa sukupuolta",
            "2": "Muokkaa pituutta",
            "3": "Muokkaa ikää"
        },
        "btn": {
            "cancelBtn": "Peruuta",
            "accomplishBtn": "Valmis",
            "confirmBtn": "OK"
        },
        "dialog": {
            "0": "Sukupuoli on yksi tärkeä peruste kehonkoostumuksen mittauksessa. Muutos voi aiheuttaa eroavaisuuksia aiempiin tietoihin verrattuna. Vahvistatko muutoksen?",
            "1": "Pituus on yksi tärkeä peruste kehonkoostumuksen mittauksessa. Muutos voi aiheuttaa eroavaisuuksia aiempiin tietoihin verrattuna. Vahvistatko muutoksen?",
            "2": "Ikä on yksi tärkeä peruste kehonkoostumuksen mittauksessa. Muutos voi aiheuttaa eroavaisuuksia aiempiin tietoihin verrattuna. Vahvistatko muutoksen?"
        },
        "rules": {
            "metricheight": {
                "0": "Syötä pituus väliltä 2 jalkaa 3 tuumaa – 6 jalkaa 7 tuumaa."
            },
            "heightMsg": {
                "0": "Syötä pituus väliltä 70–200 cm."
            },
            "ageMsg": {
                "0": "Syötä ikä väliltä 10–99 vuotta.",
                "1": "Syötit muun kuin kokonaisluvun: iän on oltava kokonaisluku. Syötä oikea ikä."
            }
        },
        "heightMsg": "Valitse pituus uudelleen",
        "ageMsg": "Valitse ikä uudelleen",
        "ModelBinding": "Joku ehti skannata koodin ennen sinua. Suorita mittaus uudelleen.",
        "ReportEmpty": {
            "title": "Sinulla ei ole vielä yhtään raporttia",
            "desc": "Etsi Visbody 3D-kehoskanneri ja tee mittaus!"
        },
        "changeSort": "Vaihda tuoteraportti",
        "setPassword": 'Aseta / Vaihda salasana',
        "describe": "Vaihdettuasi tuotemallia näet kaikki kyseisen mallin mittausraportit.",
        "describeBtn": "Vaihdettuasi tuotemallia sinut ohjataan kyseisen mallin uusimpaan mittausraporttiin.",
        "descReport": "Tuoteraportin vaihto onnistui",
        "accountSecurity": "Tili ja turvallisuus"
    },
    "modelBinding": {
        "desc": "Joku ehti skannata koodin ennen sinua. Suorita mittaus uudelleen."
    },
    "reportEmpty": {
        "title": "Sinulla ei ole vielä yhtään raporttia",
        "desc": "Etsi Visbody 3D-kehoskanneri ja tee mittaus!"
    },
    "userInfo": {
        "height": "Pituus:",
        "age": "Ikä:",
        "unit": "vuotta",
        "weight": 'Paino',
    },
    "assessment": {
        "great": "Erinomainen",
        "good": "Hyvä",
        "normall": "Keskiverto",
        "weak": "Heikko"
    },
    "mass": {
        "title": "Kehonkoostumuksen yleiskatsaus",
        "titles": "Kehonkoostumus",
        "springFrame": "Ei mittaustietoja tältä päivältä",
        "contrast": "Valitse raportti vertailtavaksi",
        "contrastReport": "Valitse vertailuraportti",
        "noRecord": "Ei tietoja",
        "score": "pistettä",
        "status": "Nykyinen kehonkoostumuksesi tila",
        "WT": "Paino",
        "PBF": "Kehon rasvaprosentti",
        "measure": {
            "value": "Mittausarvot",
            "standardRange": "Normaali vaihteluväli",
            "comparedWithLastLime": "Muutos",
            "comparedNet": "Muutos",
            "WT": "Paino",
            "FFM": "Rasvaton massa",
            "BFM": "Kehon rasvamassa",
            "LM": "Lihasmassa",
            "TBW": "Kehon kokonaisvesi",
            "SM": "Luurankolihas",
            "PROTEIN": "Proteiini",
            "TM": "Epäorgaaniset suolat",
            "BMR": "BMR",
            "WHR": "Vyötärön-lantion suhde",
            "BMI": "BMI",
            "PBF": "Kehon rasvaprosentti",
            "VFG": "Viskeraalirasvan taso",
            "unit": "kg",
            "BMRUnit": "kcal/vrk"
        },
        "explain": {
            "0": {
                "title": "Paino",
                "msg": "Paino on kehon veden, proteiinin, epäorgaanisten suolojen ja kehon rasvan summa."
            },
            "1": {
                "title": "Rasvaton massa",
                "msg": "Rasvaton massa on kehon kokonaispaino ilman rasvaa."
            },
            "2": {
                "title": "Kehon rasvamassa",
                "msg": "Kehon rasva on ihonalaisen rasvan, viskeraalirasvan ja lihasten välisen rasvan summa."
            },
            "3": {
                "title": "Lihasmassa",
                "msg": "Lihasmassa on ihmiskehon vähärasvainen kudosryhmä, joka sisältää luurankolihakset, sileät lihakset ja sydänlihaksen."
            },
            "4": {
                "title": "Kehon kokonaisvesi",
                "msg": "Kehon vesi muodostaa noin 50–70 % kehon painosta. Se sijaitsee pääasiassa soluissa ja kudosnesteissä, joista suurin osa on lihassoluissa."
            },
            "5": {
                "title": "Luurankolihas",
                "msg": "Luurankolihas, jota kutsutaan myös poikkijuovaiseksi lihakseksi, on luustoon kiinnittynyt lihas. Tässä lasketaan sen määrä."
            },
            "6": {
                "title": "Proteiini",
                "msg": "Proteiini on typpeä sisältävä kiinteä aine, jota on kaikissa kehon soluissa ja joka osallistuu solujen muodostumiseen. Se on lihasmassan pääkomponentti."
            },
            "7": {
                "title": "Epäorgaaniset suolat",
                "msg": "Ihmiskeho koostuu orgaanisista aineista, epäorgaanisista aineista ja vedestä. Kehon epäorgaanisia aineita kutsutaan epäorgaanisiksi suoloiksi, ja ne muodostavat noin 5 % kehon painosta."
            },
            "8": {
                "title": "BMR",
                "msg": "Perusaineenvaihdunta tarkoittaa energiamäärää, jonka keho kuluttaa vuorokauden aikana hereillä ja levossa ilman liikunnan, ruoan tai lämpötilan vaikutusta."
            },
            "9": {
                "title": "Vyötärön-lantion suhde",
                "msg": "Vyötärön-lantion suhde on vyötärön ja lantion ympärysmittojen suhde, ja se on tärkeä keskivartalolihavuuden määrittelyn indikaattori."
            },
            "10": {
                "title": "BMI",
                "msg": "BMI-arvoa käytetään pääasiassa lihavuuden arviointiin, ja se on yleinen kansainvälinen standardi."
            },
            "11": {
                "title": "Kehon rasvaprosentti",
                "msg": "Kehon rasvaprosentti tarkoittaa kehon rasvan osuutta kokonaispainosta."
            },
            "12": {
                "title": "Viskeraalirasvan taso",
                "msg": "Viskeraalirasvan taso on tärkeä indikaattori piilevän lihavuuden arvioinnissa."
            },
            "13": {
                "title": "Solunsisäinen neste",
                "msg": "Solunsisäinen neste: On kehon solujen sisältämä neste, joka on soluliman perusosa."
            },
            "14": {
                "title": "Solunulkoinen neste",
                "msg": "Solunulkoinen neste: Viittaa yleensä solujen ulkopuoliseen nesteeseen, mukaan lukien plasma ja verisuonten sekä kudossolujen välinen kudosneste."
            },
            "15": {
                "title": "Aineenvaihduntaikä",
                "msg": "Aineenvaihduntaikä viittaa kehon ja sen terveyteen liittyvien aineenvaihduntatoimintojen suorituskykyyn."
            },
            "16": {
                "title": 'ECW/TBW-suhde',
                "msg": 'ECW/TBW-suhde on solunulkoisen veden (ECW) osuus kehon kokonaisvesimäärästä (TBW). Se on tärkeä mittari kehon nestetasapainon arvioinnissa.',
            }
        },
        "segment": {
            "fat": "Segmentaalinen rasva",
            "muscle": "Segmentaalinen lihas",
            "right": "Oikea",
            "left": "Vasen",
            "standard": "Normaali",
            "lowStandard": "Matala",
            "superStandard": "Korkea"
        },
    },
    "shape": {
        "title": "Asennon arvioinnin yleiskatsaus",
        "titles": "Asento",
        "status": "Nykyinen asentosi tila",
        "suggest": "Suositus",
        "possibility": ", havaittu",
        "models": {
            "front": "Edestä",
            "left": "Vasen sivu",
            "right": "Oikea sivu",
            "top": "Takaa",
            "low": "Alhainen",
            "high": "Korkea",
            "normal": "Normaali"
        },
        "item": {
            "deviate": "Mittausarvot",
            "result": "Kuvaus",
            "normal": "Normaali",
            "abnormal": "Poikkeava",
            "head": "Eteenpäin työntynyt pää",
            "headSlant": "Pään kallistus",
            "roundShoulderLeft": "Eteenpäin kiertyneet hartiat (vasen puoli)",
            "roundShoulderRight": "Eteenpäin kiertyneet hartiat (oikea puoli)",
            "highLowShoudler": "Eritasolla olevat hartiat",
            "pelvis": "Lantion eteen-/taaksepäin siirtymä",
            "leftKneeCheck": "Vasemman polven arviointi",
            "rightKneeCheck": "Oikean polven arviointi",
            "leg": "Jalkojen tyyppi",
            "leftLeg": "Vasen jalka:",
            "rightLeg": "Oikea jalka:"
        },
        "explain": {
            "0": {
                "title": "Eteenpäin työntynyt pää",
                "msg": "Kulma vasemman korvapisteen ja kaulan keskikohdan yhdistävän linjan sekä sivuprofiilin keskilinjan välillä."
            },
            "1": {
                "title": "Pään kallistus",
                "msg": "Kulma pään keskipisteen ja kaulan keskikohdan välisen linjan sekä edessä olevan keskilinjan välillä."
            },
            "2": {
                "title": "Eteenpäin kiertyneet hartiat (vasen puoli)",
                "msg": "Kulma selän vasemmanpuoleisen korkeimman kohdan ja hartian tangenttilinjan välillä."
            },
            "3": {
                "title": "Eteenpäin kiertyneet hartiat (oikea puoli)",
                "msg": "Kulma selän oikeanpuoleisen korkeimman kohdan ja hartian tangenttilinjan välillä."
            },
            "4": {
                "title": "Eritasolla olevat hartiat",
                "msg": "Vasemman ja oikean olkalisäkkeen välinen pystysuora etäisyys takaa katsottuna."
            },
            "5": {
                "msg": "Kulma, jonka muodostavat kaulan keskipiste, lonkkapiste ja nilkkapiste vasemmalta sivulta katsottuna."
            },
            "6": {
                "title": "Vasemman polven arviointi",
                "msg": "Kulma, jonka muodostavat lonkkapiste, polvinivel ja nilkkapiste vasemmalta sivulta katsottuna."
            },
            "7": {
                "title": "Oikean polven arviointi",
                "msg": "Kulma, jonka muodostavat lonkkapiste, polvinivel ja nilkkapiste oikealta sivulta katsottuna."
            },
            "8": {
                "title": "Jalkojen tyyppi",
                "msg": "Kulma, jonka muodostavat lonkkapiste, polvinivel ja nilkkapiste molemmissa jaloissa edestä katsottuna."
            },
            "9": {
                "title": "Lantion kallistus eteen/taakse",
                "msg": "Pystysuoran linjan ja tason, jonka muodostavat vasen ja oikea suoliluun ylempi etukärki (ASIS) sekä häpyliitos, välinen kulma."
            },
            "10": {
                "title": "Alaraajojen pituusero",
                "msg": "Molempien pakarapoimujen alimman kohdan korkeusero lattiasta takaa katsottuna."
            }
        },
        "exception": {
            "0": {
                "title": "Kallistunut vasemmalle",
                "abnormal": ""
            },
            "1": {
                "title": "Kallistunut oikealle",
                "abnormal": ""
            },
            "2": {
                "title": "Vasen korkeammalla",
                "abnormal": ""
            },
            "3": {
                "title": "Oikea korkeammalla",
                "abnormal": ""
            },
            "4": {
                "title": "Lantion siirtymä taaksepäin",
                "abnormal": ""
            },
            "5": {
                "title": "Lantion siirtymä eteenpäin",
                "abnormal": ""
            },
            "6": {
                "title": "Vasemman polven yliojennus",
                "abnormal": ""
            },
            "7": {
                "title": "Vasemman polven koukistus",
                "abnormal": ""
            },
            "8": {
                "title": "Oikean polven yliojennus",
                "abnormal": ""
            },
            "9": {
                "title": "Oikean polven koukistus",
                "abnormal": ""
            },
            "10": {
                "title": "Pihtipolvet (K-muoto)",
                "abnormal": ""
            },
            "11": {
                "title": "D-muotoiset jalat",
                "abnormal": ""
            },
            "12": {
                "title": "Pihtipolvet (X-jalat)",
                "abnormal": ""
            },
            "13": {
                "title": "Länkisääret (O-jalat)",
                "abnormal": ""
            }
        },
    },
    "girth": {
        "title": "Kehon ympärysmitat",
        "present": "(Tämä kerta)",
        "tpl": {
            "0": {
                "title": "Kaulan ympärysmitta",
                "key": "neckGirth"
            },
            "1": {
                "title": "Vasemman olkavarren ympärysmitta",
                "key": "leftUpperArmGirth"
            },
            "2": {
                "title": "Oikean olkavarren ympärysmitta",
                "key": "rightUpperArmGirth"
            },
            "3": {
                "title": "Rinnanympärys",
                "key": "bustGirth"
            },
            "4": {
                "title": "Korkea vyötärön ympärysmitta",
                "key": "waistGirth"
            },
            "5": {
                "title": "Keskivyötärön ympärysmitta",
                "key": "midWaistGirth"
            },
            "6": {
                "title": "Lantion ympärysmitta",
                "key": "hipGirth"
            },
            "7": {
                "title": "Vasemman reiden ympärysmitta",
                "key": "leftThighGirth"
            },
            "8": {
                "title": "Vasemman reiden keskiosan ympärysmitta",
                "key": "leftMidThighGirth"
            },
            "9": {
                "title": "Vasemman reiden kapein ympärysmitta",
                "key": "leftMinThighGirth"
            },
            "10": {
                "title": "Oikean reiden ympärysmitta",
                "key": "rightThighGirth"
            },
            "11": {
                "title": "Oikean reiden keskiosan ympärysmitta",
                "key": "rightMidThighGirth"
            },
            "12": {
                "title": "Oikean reiden kapein ympärysmitta",
                "key": "rightMinThighGirth"
            },
            "13": {
                "title": "Vasemman pohkeen ympärysmitta",
                "key": "leftCalfGirth"
            },
            "14": {
                "title": "Oikean pohkeen ympärysmitta",
                "key": "rightCalfGirth"
            },
            "15": {
                "title": "Matala vyötärönympärys",
                "key": "lowWaistGirth"
            }
        },
        "noHistory": "Ei tietoja"
    },
    "shoulder": {
        "title": "Olkapää",
        "model": {
            "val": "Mittausarvot",
            "scope": "Normaali vaihteluväli",
            "diff": "Muutos"
        },
        "normal": "Normaali",
        "conclusion": "Yhteenveto",
        "analyse": "Analyysi:",
        "suggest": "Suositus:",
        "cause": "Ota yhteyttä ammattilaiseen tarkempaa arviota varten.",
        "scope": "Laajin liikerata"
    },
    "saveQr": {
        "title": "Visbody 3D-kehonmittausraportti",
        "btnMsg": "Tallenna kuva puhelimeen painamalla sitä pitkään",
        "tips": "Jos tallennus ei onnistu, siirry [Asetuksiin] ja ota käyttöoikeudet käyttöön"
    },
    reportTips: {
        title: "Haluatko varmasti poistaa tämän raportin? Poistamisen jälkeen sitä ei voi palauttaa.",
        confirm: "Poista",
        success: "Raportti on poistettu",
        partial: "Raportti on poistettu, mutta osan tiedoista synkronointi epäonnistui. Ota yhteyttä järjestelmänvalvojaan.",
        failed: "Poistaminen epäonnistui, yritä myöhemmin uudelleen.",
        "btnMsg": "OK",
        "alaryTips": "Ylläpitäjä on poistanut tämän mittausraportin. Siirrytään seuraavaan raporttiin!",
    },
    "share": {
        "title": "Kopioi alla oleva linkki jakaaksesi sen",
        "btnMsg": "Kopioi"
    },
    'bodyPrediction': {
		'body-title': 'Kehonmuodon ennuste',
		'body-yu-ce-status': 'Perustuu nykytilaan',
		'body-setting': 'Ennusteasetukset',
		'body-li-xiang': 'Ihannearvo:',
		'body-ti-zhong': 'Paino',
		'body-ti-zhi-lv': 'Rasvaprosentti',
		'body-ji-rou': 'Lihasmassa',
		'yu-che-pre': 'Ennen',
		'yu-che-after': 'Jälkeen',
		'zan-model-no': 'Ei mallia',
		'ti-xing-error': 'Ennusteen luominen epäonnistui',
		'ti-xing-worker-error': 'Tarkista verkkoyhteys ja yritä uudelleen.',
		'ti-xing-adjust': 'Säätömäärä',
		'ji-rou-title': 'Lihasmassa',
		'ti-zi-fang': 'Kehon rasva',
		'dang-pre-zhi': 'Nykyarvo:',
		'nen-zhang': 'Sisäelinrasvan taso',
		'nen-zhang-title': 'Tietoa sisäelinrasvasta',
		'nen-zhang-title1': 'Sisäelinrasva kertyy elinten ympärille ja altistaa vyötärölihavuudelle. Arvo kuvaa rasvan poikkipinta-alaa.'
	},
    "newshape": {
        "explain": {
            "0": {
                "msg": "Korvan ja kehon painopistelinjan välinen pystysuora etäisyys."
            },
            "1": {
                "msg": "Korvien välisen linjan ja vaakalinjan välinen kulma."
            },
            "2": {
                "msg": "Vasemman olkalisäkkeen ja painopistelinjan välinen pystysuora etäisyys."
            },
            "3": {
                "msg": "Oikean olkalisäkkeen ja painopistelinjan välinen pystysuora etäisyys."
            },
            "4": {
                "msg": "Kaulan tyven ja olkalisäkkeen välisen linjan ero vasemman ja oikean välillä."
            },
            "5": {
                "msg": "Lonkkanivelen ja painopistelinjan välinen pystysuora etäisyys."
            },
            "6": {
                "msg": "Kulma sagittaalitasossa nilkan, 1 cm vasemman polven alapuolella olevan pisteen ja lonkan välillä."
            },
            "7": {
                "msg": "Kulma sagittaalitasossa nilkan, 1 cm oikean polven alapuolella olevan pisteen ja lonkan välillä."
            },
            "8": {
                "msg": "Kulma koronaalitasossa vasemman/oikean lonkan, polven ja nilkan välillä."
            }
        },
        "item": {
            "pelvis": "Lantion siirtymä eteenpäin"
        }
    },
    "shap": {
        "item": {
            "keAbnormal": "Mahdollinen poikkeavuus"
        }
    },
    "setPassword": "Aseta / Vaihda salasana",
    "resetTitle": "Aseta salasana",
    "password": "Salasana",
    "placeholder": "Syötä salasana",
    "codeLogin": "Kirjaudu vahvistuskoodilla",
    "accountLogin": "Kirjaudu salasanalla",
    "forgotPassword": "Unohditko salasanan?",
    "registerTips-01": "Eikö sinulla ole vielä tiliä?",
    "registerTips-03": "Tili on jo olemassa",
    "checkRule-01": "8–20 merkkiä",
    "checkRule-02": "Vähintään yksi iso kirjain",
    "checkRule-03": "Vähintään yksi pieni kirjain",
    "checkRule-04": "Vähintään yksi numero",
    "checkRule-05": "Salasanat eivät täsmää",
    "errorTips-01": "Virheellinen salasana",
    "errorTips-02": "Kirjautuminen epäonnistui",
    "errorTips-03": "Tiliä ei ole olemassa",
    "reset-01": "Nollaa salasana",
    "reset-02": "Seuraava",
    "reset-03": "Vahvistuskoodi on vanhentunut",
    "reset-04": "Uusi salasana ei voi olla sama kuin edellinen",
    "reset-05": "Ohita",
    "reset-06": "Salasanan asettaminen onnistui",
    "reset-07": "Virheellinen vahvistuskoodi",
    "setPasswordTips": "Salasanan on oltava 8–20 merkkiä pitkä ja sisällettävä isoja kirjaimia, pieniä kirjaimia ja numeroita.",
    "ai": {
        "report": "Tekoälyn raporttitulkinta",
        "train": "Harjoitusohjelma",
        "loading": "Ladataan, odota hetki...",
        "loadingError1": "Raportin lataus epäonnistui",
        "loadingError2": "Pahoittelemme häiriötä. Yritä myöhemmin uudelleen."
    },
    "wifi": {
        "title": "Wi-Fi-asetukset",
        "tips": "Syötä salasana seuraavalle Wi-Fi-verkolle.",
        "password": "Wi-Fi-salasana",
        "password-placeholder": "Syötä Wi-Fi-salasana.",
        "password-tips": "Salasana on merkkikokoriippuvainen. Varmista, että syötät sen oikein.",
        "button": "Luo QR-koodi",
        "h5-title": "Määritä Wi-Fi-tiedot",
        "wifi-name": "Wi-Fi-verkon nimi:",
        "wifi-password": "Wi-Fi-salasana:",
        "wifi-qr-tips1": "* Varmista, että Wi-Fi-verkon nimi ja salasana ovat oikein. Kohdista sitten laitteen näytön alla olevaan kameraan skannataksesi.",
        "wifi-qr-tips2": "Kohdista Wi-Fi-QR-koodi näytön alla olevaan kameraan skannataksesi.",
        "wifi-qr-button": "Takaisin"
    },
    "waist": {
        "title": "Vyötärön ja vatsan ympärysmitta",
        "hou": "Takaa",
        "qian": "Edestä"
    },
    "yao_wei_1": "Vyötärö",
    "yao_bu_fen_shu": "Vyötärön pisteet",
    "waist_fen": "pistettä",
    "yao_wei": "Vyötärönympärys",
    "yao_wei_jian_ti_ji": "Vyötärönympäryslinjojen välinen tilavuus",
    "yao_tun_bi": "Vyötärön-lantion suhde",
    "lun_kuo_fen_xi": "Ääriviiva-analyysi",
    "bei_bu": "Selän alue",
    "tunbu": "Pakarat",
    "bei_bu_ti_ji": "Selän tilavuus",
    "zheng_chang_fan_wei": "Normaali vaihteluväli:",
    "shang_ci": "Edellinen",
    "ben_ci": "Nykyinen",
    "gupen": {
        "zheng_chang": "Normaali",
        "qian_qin_yan_chang": "Poikkeava kallistus eteenpäin",
        "qian_qin_yi": "Eteenpäin kallistumisen riski",
        "hou_qin_yi": "Taaksepäin kallistumisen riski",
        "hou_qin_yan_chang": "Poikkeava kallistus taaksepäin",
        "zuo_chang_yan_chang": "Poikkeava pituus (vasen pidempi)",
        "zuo_chang_yi": "Pituuseron riski (vasen pidempi)",
        "you_chang_yi": "Pituuseron riski (oikea pidempi)",
        "you_chang_yan_chang": "Poikkeava pituus (oikea pidempi)"
    },
    "gao_yao_xian": "Korkea vyötärön ympärysmitta",
    "gao_yao_zhong_xian": "Korkean vyötärön keskilinja",
    "gao_yao_xia_xian": "Korkean vyötärön alalinja",
    "xiao_yao_shang_xian": "Matalan vyötärön ylälinja",
    "xiao_yao_zhong_xian": "Matalan vyötärön keskilinja",
    "xiao_yao_xian": "Matala vyötärönympärys",
    "qv_jian1": "Korkean vyötärön yläosa",
    "qv_jian2": "Korkean vyötärön alaosa",
    "qv_jian_zhong": "Keskivyötärön alue",
    "qv_jian3": "Matalan vyötärön yläosa",
    "qv_jian4": "Matalan vyötärön alaosa",
    "celiang": {
        "failed": "Mittaus epäonnistui. Käytä ihonmyötäisiä vaatteita ja pysy paikallasi mittauksen aikana."
    },
    "jie-gou-yi-chang-ping-gu": "Rakenteellisten poikkeavuuksien arviointi",
    "teng-tong-feng-xian-ping-gu": "Kipuriskin arviointi",
    "zheng-chang": "Normaali",
    "qing-du-yi-chang": "Lievä poikkeavuus",
    "zhong-du2-yi-chang": "Kohtalainen",
    "zhong-du-yi-chang": "Vakava poikkeavuus",
    "gu-pen-zhuan-xiang-feng-xian-ping-gu": "Lantion erityisriskiarviointi",
    "qian-qing": "Eteenpäin kallistuminen",
    "hou-qing": "Taaksepäin kallistuminen",
    "xuan-zhuan": "Kiertyminen",
    "pen-gu-qian-qing-feng-xian-fen-shu": "Lantion eteenpäin kallistumisen riskipisteet",
    "pen-gu-hou-qing-feng-xian-fen-shu": "Lantion taaksepäin kallistumisen riskipisteet",
    "pen-gu-xuan-zhuan-feng-xian-fen-shu": "Lantion kiertymisen riskipisteet",
    "fen": "pistettä",
    "gao-feng-xian": "Korkea riski",
    "ji-rou-ping-gu-jie-guo": "Lihasten arviointitulokset",
    "qian-qing-feng-xian-gao": "Korkea eteenpäin kallistumisen riski",
    "hou-qing-feng-xian-gao": "Korkea taaksepäin kallistumisen riski",
    "xuan-zhuan-feng-xian-gao": "Korkea kiertymisen riski",
    "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Lanne-suoliluulihas ja selän ojentajalihaksen alaosa ovat kireät, ja poikittainen vatsalihas on heikko.",
    "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo": "Takareidet, pakaralihakset ja selän ojentajalihakset ovat kireät, ja lanne-suoliluulihas on heikko.",
    "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng": "Keskimmäisessä pakaralihaksessa on toispuoleinen heikkous, ja neliömäisessä lannelihaksessa epätasapainoa.",
    "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Lantioon liittyvien lihasten arviointi on normaali. Jatka hyviä elämäntapoja.",
    "yi-shang-xiang-mu-jun-zheng-chang": "Kaikki yllä olevat kohteet ovat normaaleja",
    "ji-zhu-jie-gou-yi-chang-ping-gu": "Selkärangan rakenteen poikkeavuuksien arviointi",
    "zheng-ti-ping-fen": "Kokonaispisteet",
    "jing-zhui": "Kaularanka",
    "xiong-zhui": "Rintaranka",
    "yao-zhui": "Lanneranka",
    "jing-zhui-jie-gou-yi-chang-ping-fen": "Kaularangan rakenteellisten poikkeavuuksien pisteet",
    "xiong-zhui-jie-gou-yi-chang-ping-fen": "Rintarangan rakenteellisten poikkeavuuksien pisteet",
    "yao-zhui-jie-gou-yi-chang-ping-fen": "Lannerangan rakenteellisten poikkeavuuksien pisteet",
    "jing-zhui-ji-rou-ping-gu": "Kaularangan lihasten arviointi",
    "xiong-zhui-ji-rou-ping-gu": "Rintarangan lihasten arviointi",
    "yao-zhui-ji-rou-ping-gu": "Lannerangan lihasten arviointi",
    "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "Selkärangan yleislinjaus on pääosin normaali.",
    "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang": "Pään asento ja kaularangan linjaus ovat pääosin normaalit.",
    "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Pään eteenpäintyöntyminen/kallistus ja lievä C-rangan poikkeama. Huomioi istuma-asento.",
    "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Pään eteenpäintyöntyminen/kallistus ja C-rangan poikkeama. Ryhdinhallinta ja harjoittelu suositellaan.",
    "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Merkittävä pään kallistus ja C-rangan poikkeama. Ammattilaisen arvio suositellaan.",
    "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang": "Rintarangan linjaus on pääosin normaali, eikä selkeitä rakenteellisia poikkeavuuksia ole.",
    "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Lievä Th-rangan poikkeama. Suositellaan ryhdinhallinnan parantamista.",
    "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Th-rangan poikkeama vaikuttaa vakauteen. Kohdennettu harjoittelu suositellaan.",
    "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Merkittävä Th-rangan poikkeama ja epäsymmetria. Ammattilaisen korjaus suositellaan.",
    "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "Lannerangan linjaus on normaali, asento on tasapainossa, eikä selkeitä rakenteellisia poikkeavuuksia ole.",
    "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Lievä L-rangan poikkeama, ryhti tasapainossa. Keskivartalon stabilointi suositellaan.",
    "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "L-rangan poikkeama vaikuttaa vakauteen. Korjaava harjoittelu suositellaan.",
    "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Merkittävä L-rangan poikkeama. Ammattilaisen parannussuunnitelma suositellaan.",
    "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hypertonia: m. levator scapulae, SCM, ylä-trapezius. Heikkous: syvät niskan koukistajat. Stabilointi ja rentoutus suositellaan.",
    "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hypertonia: vasen SCM ja m. scalenus posterior. Heikkous: oikea SCM. Bilateraalinen tasapaino ja rentoutus suositellaan.",
    "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hypertonia: oikea SCM. Heikkous: vasen SCM ja m. scalenus posterior. Symmetrinen stabilointi ja rentoutus suositellaan.",
    "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hypertonia: vasen ylä-trapezius. Heikkous: keski-/ala-trapezius. Harjoittelu (keski/ala) ja rentoutus suositellaan.",
    "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hypertonia: lonkan sisäkiertäjät ja lähentäjät. Heikkous: m. gluteus medius. Pakaratreeni ja venyttely suositellaan.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hypertonia: m. gluteus medius ja m. piriformis. Heikkous: lähentäjät, sisäkiertäjät, LCL. Jalkojen stabilointi ja pakaroiden rentoutus suositellaan.",
    "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hypertonia: m. gluteus medius ja m. piriformis. Toispuolinen heikkous: lähentäjät, sisäkiertäjät, LCL. Bilateraalinen harjoittelu suositellaan.",
    "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Suositellaan tasapainoista harjoittelua ja toispuoleisen ylirasituksen välttämistä.",
    "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hypertonia: vasen takareisi ja m. popliteus. Heikkous: m. quadriceps ja m. soleus. Quadriceps-/soleus-treeni ja venyttely suositellaan.",
    "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hypertonia: vasen m. quadriceps. Heikkous: m. gluteus maximus ja takareidet. Pakara-/takaketjutreeni ja venyttely suositellaan.",
    "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hypertonia: oikea takareisi ja m. popliteus. Heikkous: m. quadriceps ja m. soleus. Quadriceps-/soleus-treeni ja venyttely suositellaan.",
    "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hypertonia: oikea m. quadriceps. Heikkous: m. gluteus maximus ja takareidet. Pakara-/takaketjutreeni ja venyttely suositellaan.",
    "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Lievä selkärangan poikkeama. Huomioi ryhti ja treenaa keskivartaloa.",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Kohtalainen selkärangan poikkeama. Ammattilaisen ohjaama harjoittelu suositellaan.",
    "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "Lihasten arviointi on normaali. Jatka hyviä elämäntapoja.",
    "teng-tong-qian-zai-feng-xian-ping-gu": "Potentiaalisen kivun riskinarviointi",
    "jing-bu": "Niska",
    "bei-bu": "Selän alue",
    "yao-bu": "Vyötärö",
    "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Potentiaalisen niskakivun riskipisteet",
    "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Potentiaalisen selkäkivun riskipisteet",
    "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "Potentiaalisen alaselkäkivun riskipisteet",
    "di-feng-xian": "Matala riski",
    "zhong-feng-xian": "Kohtalainen riski",
    "ji-zhu-jie-gou-ke-shi-hua": "Selkärangan rakenteen visualisointi",
    "tuo-dong-xuan-zhuan-shi-tu": "Kierrä näkymää vetämällä",
    "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun": "Tämä malli on vain viitteellinen. Tarkka arviointi perustuu ammattilaisen tekemään arviointiin.",
    "bei-mian": "Takaa",
    "zheng-shi-tu": "Edestä katsottuna",
    "you-shi-tu": "Oikealta katsottuna",
    "hou-shi-tu": "Takaa katsottuna",
    "zuo-shi-tu": "Vasemmalta katsottuna",
    "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hypertonia: oikea ylä-trapezius. Heikkous: keski-/ala-trapezius. Harjoittelu (keski/ala) ja rentoutus suositellaan.",
    "tun-xing": "Pakaran muoto",
    "dui-bi": "Vertailu",
    "fang-xing-tun": "Neliönmuotoinen pakara",
    "li-xing-tun": "Päärynänmuotoinen pakara",
    "dao-san-jiao-xing-tun": "Käänteisen kolmion muotoinen pakara",
    "yuan-xing-tun": "Pyöreä pakara",
    "jiao-li-xiang": "Melko ihanteellinen",
    "mi-tao-tun": "Persikanmuotoinen pakara",
    "ben-ci": "Tämä kerta",
    "li-shi": "Historia",
    "ben-ci-li-shi": "Tämä kerta, Historia",
    "tun-wei": "Lantion ympärysmitta",
    "tun-xing-shuo-ming": "Pakaran muodon kuvaus",
    "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai": "Pakaran muoto tarkoittaa selän alaosan ja reisien välisen alueen muodostamaa käyrää ja muotoa. Pakaran muodon arviointi auttaa ulkonäön ja terveyden hallinnassa entistä paremmin.",
    "wo-zhi-dao-le": "Ymmärretty",
    "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du": "Neliönmuotoinen pakara: Näyttää ylhäältä ja alhaalta yhtä leveältä, ja sivulinjat ovat suorat ilman kaarta.",
    "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing": "Pyöreä pakara: Rasva on jakautunut tasaisesti, muoto on pyöreä ja täyteläinen. Erittäin ihanteellinen pakaran muoto.",
    "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man": "Päärynänmuotoinen pakara: Ylhäältä kapea ja alhaalta leveä. Lihasta ja rasvaa on enemmän pakaran alaosassa, ja linja ei ole yhtä täyteläinen.",
    "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing": "Käänteisen kolmion muotoinen pakara: Ylhäältä leveä ja alhaalta kapea, muistuttaen käänteistä kolmiota.",
    "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing": "Persikanmuotoinen pakara: Visuaalisesti persikkaa muistuttava muoto. Pakaran alaosa on täyteläinen ja vyötärö kapea. Erittäin ihanteellinen pakaran muoto",
    "zan-wu-mo-xing": "Mallia ei saatavilla",
    "ce-liang": "Mittaus",
    "ben-ci-ce-liang": "Tämä mittaus",
    "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang": "Tämän mittauksen mallin muodostus epäonnistui. Voit suorittaa mittauksen uudelleen laitteella.",
    "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi": "Tälle päivämäärälle ei ole mallia. Valitse toinen vertailupäivä.",
    "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "Ensimmäinen mittaus, ei aiempia tietoja.",
    "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia": "Mallin lataus epäonnistui, päivitä sivu ja yritä uudelleen.",
    "jing-zhui-7": "Kaularangan 7. nikama",
    "di-gu-zhong-dian": "Ristiluun keskipiste",
    "di-gu-hou-shang-jiao": "Ristiluun takayläkulma",
    "ren-ti-zhong-xin": "Kehon painopiste",
    "spine-tips1": "Tämä raportti on vain viitteellinen, eikä sitä ole tarkoitettu lääketieteelliseksi diagnoosiksi. Suositellaan kokonaisvaltaista arviota yhdessä lääkärin lausunnon kanssa.",
    "spine-tips2": "2025 Visbody selkärangan erityisarviointijärjestelmä",
    "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu": "Vakava poikkeama selkärangan rakenteessa. Suositellaan hakeutumista lääkäriin moniammatillista arviointia varten.",
    "tun-xing-ping-gu": "Pakaran muodon arviointi",
    "yi-xia-shi-nin-de-tun-xing-lei-xing": "Alla on pakaran muototyyppisi",
    "qi-ta-tun-xing": "Muut pakaran muototyypit",
    "ji-zhu-ping-gu": "Selkärangan arviointi",
    "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu": "Nuorten selkärangan erityinen riskiarviointi",
    "xue-xi-zi-shi-fu-he-zhi-shu": "Opiskeluasennon kuormitusindeksi",
    "gu-ge-ping-heng-zhi-shu": "Luuston tasapainoindeksi",
    "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "Kasvukauden kipuvaroitusindeksi",
    "ji-zhu-ce-wan-feng-xian-ping-fen": "Skolioosiriskipisteet",
    "qia-yao-ji-shu-ji-ji": "Lanne-suoliluulihas / Selän ojentajalihas",
    "xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "Alaosa on kireä, ja poikittainen vatsalihas on heikko",
    "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti": "Selkärangan kehitys on normaali, eikä selkeitä rakenteellisia ongelmia ole.",
    "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan": "Selkärangan kehityksessä on lievä häiriöriski. Suositellaan asentotottumusten parantamista.",
    "zhong-du-fa-yu-feng-xian": "Kohtalainen kehitysriski.",
    "yan-zhong-ying-xiang-ji-zhu-fa-yu": "Vaikuttaa vakavasti selkärangan kehitykseen.",
    "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi": "Opiskeluasento on hyvä, voidaan ylläpitää pitkään.",
    "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi": "Asennossa parannettavaa, suositellaan taukoa 45 minuutin välein.",
    "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen": "Selkeä ryhtiongelma, vaatii säännöllistä venyttelyä.",
    "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu": "Erittäin huono opiskeluasento, voi vaikuttaa oppimistehokkuuteen ja kehitykseen.",
    "gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding": "Luuston kehitys on symmetristä, ja asento on vakaa.",
    "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce": "Lievää epäsymmetriaa on havaittavissa, suositellaan seurantaa.",
    "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi": "Epätasainen kehitys, vaatii korjaavia toimenpiteitä.",
    "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang": "Vakava luuston epäsymmetria, joka voi vaikuttaa kasvuun.",
    "zi-shi-liang-hao-teng-tong-feng-xian-di": "Hyvä ryhti, matala kipuriski.",
    "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li": "Lievä kipuriski, suositellaan asennonhallintaa.",
    "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao": "Kohtalainen kipuriski, ja se vaatii ammattilaisen ohjausta.",
    "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan": "Korkea kipuriski, epämukavuutta saattaa jo esiintyä.",
    "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan": "Matala riski, ylläpidä hyviä asentotottumuksia.",
    "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu": "Kohtalainen riski, saattaa vaatia lisäseurantaa tai toimenpiteitä.",
    "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu": "Korkea riski, vaatii välitöntä lääketieteellistä arviointia ja hoitoa.",
    "you-liang": "Erinomainen",
    "zhu-yi": "Huomio",
    "gan-yu": "Toimenpiteet",
    "jing-shi": "Varoitus",
    "di-fu-he": "Matala kuormitus",
    "zhong-fu-he": "Kohtalainen kuormitus",
    "gao-fu-he": "Korkea kuormitus",
    "guo-zai": "Ylikuormitus",
    "an-quan": "Turvallinen",
    "wei-xian": "Vaarallinen",
    "ping-heng-xing": "Tasapainoinen",
    "qing-du-bu-ping-heng": "Lievä epätasapaino",
    "zhong-du-bu-ping-heng": "Kohtalainen epätasapaino",
    "yan-zhong-bu-ping-heng": "Vakava epätasapaino",
    "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "Nuorten selkärangan kehitysindeksi",
    "vanCalendar": {
        "end": 'Loppu',
        "start": 'Alku',
        "title": 'Valitse päivämäärä',
        "confirm": 'Vahvista',
        "startEnd": 'Alku/Loppu',
        "weekdays": ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
        monthTitle: function monthTitle(year, month) {
            return  year+ '/' + month;
        },
        rangePrompt: function rangePrompt(maxRange) {
            return "\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 " + maxRange + " \u5929";
        }
    },
    "balanceReport": {
        "scoreUnit": "pistettä",
        "compareLast": "Muutos",
        "status": {
            "excellent": "Erinomainen",
            "good": "Hyvä",
            "medium": "Kohtalainen",
            "fair": "Keskiverto",
            "poor": "Heikko"
        },
        "levelDesc": {
            "0": "Erinomainen",
            "1": "Hyvä",
            "2": "Keskiverto",
            "3": "Heikko"
        },
        "systemEvaluation": "Sensorinen arviointi",
        "visualEvaluation": "Visuaalinen arviointi",
        "evaluationLevel": "Arvosana",
        "swayRms": "Huojunnan määrä",
        "eyeCloseTest": "Staattinen tasapaino (silmät kiinni)",
        "copArea": "COP-alue (Painopisteen alue)",
        "avgSpeed": "Keskinopeus",
        "maxDisplacement": "Suurin poikkeama",
        "centerTrajectory": "COP-liikerata",
        "eyeOpenTest": "Staattinen tasapaino (silmät auki)",
        "last": "Edellinen mittaus",
        "conclusion": {
            "eyeClose": {
                "level1": "Staattinen tasapainosi silmät kiinni on erinomaisella tasolla (Taso A). Proprioseptisen ja vestibulaarisen järjestelmän tehokas integraatio mahdollistaa tasapainon ylläpitämisen ilman näköaistia. Pystyt liikkumaan turvallisesti ja vakaasti pimeässä ympäristössä (esim. yöllä noustessa tai kävellessä valojen sammuttua).",
                "level2": "Staattinen tasapainosi silmät kiinni on hyvällä tasolla (Taso B). Proprioseptinen kompensaatiokyky on hyvä, ja pystyt mukauttamaan painopistettä näköaistin puuttuessa. Päivittäiset silmät kiinni tehtävät toiminnot onnistuvat normaalisti, ja vain äkillinen silmien sulkeminen vaatii lyhyen mukautumisen.",
                "level3": "Staattinen tasapainosi silmät kiinni on keskivertotasolla (Taso C). Proprioseptisen tai vestibulaarisen järjestelmän heikentynyt toiminta lisää huojuntaa, ja ilman näköaistia (esim. pimeässä tai esineitä nostettaessa silmät kiinni) voi esiintyä huimausta ja epävakautta. Tasapainon tukeminen voi olla tarpeen kaatumisriskin pienentämiseksi.",
                "level4": "Staattinen tasapainosi silmät kiinni on heikko (Taso D). Taustalla voi olla hermoston tai proprioseptisen järjestelmän häiriö, mikä tekee tasapainon ylläpitämisestä ilman näköaistia hyvin vaikeaa. Kaatumisriski pimeässä ympäristössä on selvästi kohonnut."
            },
            "eyeOpen": {
                "level1": "Staattinen tasapainosi silmät auki on erinomaisella tasolla (Taso A). Visuaalisen ja somaattisen aistijärjestelmän tehokas integraatio mahdollistaa vakaan ja energiatehokkaan seisoma-asennon. Pystyt säilyttämään tasapainon myös haastavissa ympäristöissä (esim. epätasaisella alustalla tai ihmisjoukossa), ja sopeutumiskykysi ympäristön muutoksiin on erinomainen.",
                "level2": "Staattinen tasapainosi silmät auki on hyvällä tasolla (Taso B). Painopisteen hallinta perustuu pääasiassa näköpalautteeseen, jota somaattinen aistijärjestelmä tukee. Päivittäinen seisominen ja kävely sujuvat normaalisti, ja suoriutuminen on vakaata yksinkertaisissa ja visuaalisesti yhtenäisissä ympäristöissä.",
                "level3": "Staattinen tasapainosi silmät auki on keskivertotasolla (Taso C). Asennonhallinta on melko epävakaata, ja kyky hyödyntää näköpalautetta painopisteen hallinnassa on riittämätön. Visuaalisesti häiritsevissä ympäristöissä (esim. kirkkaassa valossa tai nopeasti liikkuvan taustan edessä) epävakaus korostuu, ja pitkäkestoinen seisominen vaatii toistuvia asennon korjauksia.",
                "level4": "Staattinen tasapainosi silmät auki on heikko (Taso D). Seisoma-asennossa esiintyy selvää huojuntaa, ja kyky hyödyntää näköpalautetta painopisteen hallinnassa on heikko. Taustalla voi olla visuaalisen, vestibulaarisen ja proprioseptisen järjestelmän integraatiohäiriö. Tasapaino päivittäisissä toiminnoissa (esim. portaissa kulkeminen tai kadun ylitys) on selvästi heikentynyt, ja kaatumisriski on kohonnut."
            }
        },
        "levelStatus": {
            "A": "Taso A",
            "B": "Taso B",
            "C": "Taso C",
            "D": "Taso D"
        },
        "chart": {
            "eyeCloseTest": "Seisontatesti silmät kiinni",
            "eyeOpenTest": "Seisontatesti silmät auki",
            "yAxisLabels": {
                "0": "Matala",
                "1": "Kohtalainen",
                "2": "Korkea"
            }
        },
        "selectionRport": "Valitse raportti vertailtavaksi",
        "measureDes": "Mittauskohteiden erittely",
        "balanceTittle": "Tasapainon arviointi",
        "pingDes": "Arvosanat: Erinomainen, Hyvä, Keskiverto, Heikko"
    },
  "neckReport": {
  "title": "Niskan toiminta",
  "conclusion": "Niskan toiminnan arviointi",
  "loading": "Raporttia luodaan. Odota hetki.",
  "failed": "Raportin koostaminen epäonnistui",
  "analysis": "Analyysi",
  "suggestion": "Suositus",
  "suggestionText": "Ota yhteyttä ammattilaiseen tarkempaa syyn selvitystä ja hoitoa varten."
}
}
